import { render, staticRenderFns } from "./ResolutionTooltip.vue?vue&type=template&id=0b2bf2bc&"
import script from "./ResolutionTooltip.vue?vue&type=script&lang=js&"
export * from "./ResolutionTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports